import { render, staticRenderFns } from "./ExameCenterLayout.vue?vue&type=template&id=56d39645&scoped=true&"
import script from "./ExameCenterLayout.vue?vue&type=script&lang=js&"
export * from "./ExameCenterLayout.vue?vue&type=script&lang=js&"
import style0 from "./ExameCenterLayout.vue?vue&type=style&index=0&id=56d39645&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d39645",
  null
  
)

export default component.exports